import { render, staticRenderFns } from "./editBookSAA.vue?vue&type=template&id=5b2a411f&"
import script from "./editBookSAA.vue?vue&type=script&lang=js&"
export * from "./editBookSAA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports